import { MenuBook } from '../../models';
import CourseRow from '../CourseRow';
import GenreRowList from '../GenreRowList';

export interface CourseRowListProps {
  menuBook: MenuBook;
}

function CourseRowList({ menuBook }: CourseRowListProps) {
  return (
    <>
      {menuBook.courses &&
        menuBook.courses.map((course) => (
          <CourseRow key={`course-${course.id}`} menuBook={menuBook} course={course}>
            <GenreRowList menuBook={menuBook} course={course} />
          </CourseRow>
        ))}
    </>
  );
}

export default CourseRowList;
